import { render, staticRenderFns } from "./FiltersSalesOrdersComponent.vue?vue&type=template&id=5b6e4c40&scoped=true&"
import script from "./FiltersSalesOrdersComponent.vue?vue&type=script&lang=js&"
export * from "./FiltersSalesOrdersComponent.vue?vue&type=script&lang=js&"
import style0 from "./FiltersSalesOrdersComponent.vue?vue&type=style&index=0&id=5b6e4c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e4c40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VIcon,VMenu,VSelect,VSpacer,VTextField})
